import styled from 'styled-components';

interface ButtonProps {
  buttonColor: string;
}

export const ItemColor: { [key: string]: string } = {
  green: 'green',
  purple: 'purple',
};

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  width: 100%;
  padding: 0;
  min-height: 13.25vh;
  background-color: ${({ theme }) => theme.menuBackground};
`;

export const LeftContent = styled.div``;

export const MidContent = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  align-items: center;
  cursor: pointer;

  img {
    height: 12.5vh;
    /* width: 5.9vw; */
    width: auto;
  }

  svg {
    color: ${({ theme }) => theme.icon};
  }
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 0 1rem;

  width: 10.5vw;

  svg {
    color: ${({ theme }) => theme.icon};
  }
`;

export const Button = styled.button<ButtonProps>`
  padding: 0.2rem 0.5rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, buttonColor }) =>
    buttonColor === 'purple' ? theme.purple : theme.green};

  :hover {
    filter: brightness(1.1);
  }

  p {
    color: ${({ theme }) => theme.white};
    font-weight: bold;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    margin: 0;
  }

  svg {
    color: ${({ theme }) => theme.white};
    margin-left: 0.5rem;
  }
`;
